<template>
  <custom-dialog appendToBody width="500px" :title="model.title" :visible="visible" v-on="$listeners">
    <div class="dialog-body">
      <el-form :model="form" :rules="rules" :validate-on-rule-change="false" ref="form">
        <el-form-item :label="$t('role_dialog.gang_wei_ming_cheng')" prop="roleName">
          <el-input v-model="form.roleName" placeholder=""></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
      <el-button type="warning" @click="saveRole">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins.js';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      form: {
        roleId: '',
        roleDesc: '',
        roleName: '',
        roleType: '',
        state: 1,
      },
    };
  },
  computed: {
    rules() {
      return {
        roleName: [
          {
            required: true,
            message: this.$t('Common.com_required'),
          },
          {
            max: 20,
            message: this.$t('Common.com_required'),
          },
        ],
        roleType: {
          required: true,
          message: this.$t('Common.com_required'),
        },
      };
    },
  },
  mounted() {
    this.initDialog();
  },
  methods: {
    // 初始化
    initDialog: function () {
      if (this.model.type === 'edit') {
        this.$setFormatData(this.form, this.model.row);
      } else {
        this.getDictionaryCodeValue('bas_role_type', (res) => {
          this.form.roleType = res.bas_role_type.org_role;
        });
      }
    },
    // 确认保存岗位
    saveRole: function () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        if (this.model.type === 'add') {
          this.saveAddRole();
        }
        if (this.model.type === 'edit') {
          this.saveEditRole();
        }
      });
    },
    // 保存新增岗位
    saveAddRole: function () {
      this.$postJSON(apis.RoleAdd, this.form, true).then(() => {
        this.$message({
          message: this.$t('Common.com_add_success'),
          type: 'success',
        });
        this.visible = false;
        this.$emit('success');
      });
    },
    // 保存编辑岗位
    saveEditRole: function () {
      this.$postJSON(apis.RoleUpdate, this.form, true).then(() => {
        this.$message({
          message: this.$t('Common.com_edit_success'),
          type: 'success',
        });
        this.visible = false;
        this.$emit('success');
      });
    },
  },
};
</script>

<style lang="scss"></style>
